export const MemberDayTagName = 'Member Offer Day';

export const MemberDayTagNames = [
  'Member Offer Day',
  'Día Livli Family',
  'Member Day',
  'Dia do Membro',
];

export const createMemberDayTagMatcher = (value?: string | null) => {
  const names = new Set(
    (value == null ? MemberDayTagNames : value.split('|'))
      .map((name) => name.trim().toLowerCase())
      .filter(Boolean),
  );

  return (tag?: string | null): boolean =>
    typeof tag === 'string' && names.has(tag.trim().toLowerCase());
};

